import { TransactionHistory, HistoryTransactionsPayload, HistoryOperationType } from '@/backend/api'
import { DATE_FORMAT, formatDate } from '@/utils/lib/formatDate'

export const getSortedHistory = (history: TransactionHistory[]): TransactionHistory[] =>
  [...history].sort((a, b) => (new Date(a.time) > new Date(b.time) ? -1 : 1))

export const getMonths = (history: TransactionHistory[]): Set<string> => {
  const months = new Set<string>()
  history.forEach(item => months.add(formatDate(new Date(item.time), DATE_FORMAT.MONTH_AND_YEAR)))

  return months
}

type GroupHistoryByMonth = Record<string, TransactionHistory[]>
type HistoryListByMonth = Array<{ month: string; list: TransactionHistory[] }>

export const groupHistoryByMonths = (historyByMonth: GroupHistoryByMonth, months: Set<string>): HistoryListByMonth => {
  const historyListByMonth: HistoryListByMonth = []
  months.forEach(item => {
    historyListByMonth.push({ month: item, list: historyByMonth[item] })
  })

  return historyListByMonth
}

export const getHistoryByMonth = (history: TransactionHistory[]): GroupHistoryByMonth => {
  return history.reduce<GroupHistoryByMonth>((accumulator, historyItem) => {
    const date = formatDate(new Date(historyItem.time), DATE_FORMAT.MONTH_AND_YEAR)
    accumulator[date] = [...(accumulator[date] || []), historyItem]

    return accumulator
  }, {})
}

export type Filter = { label: string; value: HistoryOperationType | 'ALL' }

export const getFilterParamsFromDropdown = (source: Filter): HistoryTransactionsPayload['filterParams'] => {
  return source.value === 'ALL'
    ? {}
    : {
        historyItemType: source.value,
      }
}

export const getHistoryListByMonth = (history?: TransactionHistory[]): HistoryListByMonth => {
  if (!history) {
    return []
  }

  const sortedHistory = getSortedHistory(history)
  const historyByMonth = getHistoryByMonth(sortedHistory)
  const months = getMonths(sortedHistory)
  const historyListByMonth = groupHistoryByMonths(historyByMonth, months)

  return historyListByMonth
}
